import { useApplicationContext } from 'shared/utils/applicationContext';
import { ERuntimeSettings } from 'shared/types/runtimeSettings';

/** В webview не проводим эксперимент */
export const useIsMortgageRedirectEnabled = (): boolean => {
  const { config } = useApplicationContext();

  const isMortgageRedirectEnabled = config.get<boolean>(ERuntimeSettings.isMortgageRedirectEnabled) ?? false;
  const isWebView = config.get<boolean>(ERuntimeSettings.isWebView) ?? false;

  return isMortgageRedirectEnabled && !isWebView;
};
